import { render, staticRenderFns } from "./DrawerFormSVG.vue?vue&type=template&id=3ccebd1a"
import script from "./DrawerFormSVG.vue?vue&type=script&lang=ts"
export * from "./DrawerFormSVG.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports